<template>
  <div id="app">
  <v-layout ml-5 mt-2>
    
    <v-flex xs11 ml-1>
      <v-card>
        <v-layout>
          <v-flex ml-2 > <h1>เปรียบเทียบสถิติการเกิดการตาย</h1></v-flex>
        </v-layout>
        <!-- <v-layout mt-0 mb-2>
          <v-flex ml-5 > 
            <v-autocomplete
             
              v-model="statType"
              :items="typeList"
              item-text="desc"
              item-value="code"
              no-data-text="ไม่พบข้อมูล"
              class="text-no-padding"
              placeholder="ระบุสถิติที่ต้องการแสดง"
            /></v-flex>
             <v-flex ml-5 > 
            <v-autocomplete
             
              v-model="yymm"
              :items="getPlaceList"
              item-text="text"
              item-value="code"
              return-object
              no-data-text="ไม่พบข้อมูล"
              class="text-no-padding"
              placeholder="ระบุปี "
              v-on:change="checkdata"
            /></v-flex>
        </v-layout> -->
        <line-chart ref="test" v-if="chartData" :chartdata="chartData" :height="200"  ></line-chart>
       </v-card>
    </v-flex>
  </v-layout>

  
  </div>
</template>

<script>
  // import LineChart from '@/components/LineChart'
  import LineChart from '@/components/LineChart'
  import PieChart from '@/components/PieChart'
  import axios from "axios";
  import general from '../js/general.js'
  // import BubbleChart from '@/components/BubbleChart'
  // import Reactive from '@/components/Reactive'

  export default {
    name: 'VueChartJS',
    components: {
      // LineChart,
      LineChart,
      PieChart,
      // BubbleChart,
      // Reactive
    },
    watch:{
     chartData(val) {
       console.log(val)
     }
    },
    data() {
      return {
        setyear:null,
        titleText:'จำนวนประชากรและบ้าน',
        statType:41,
        province:{ descWithCode: "10 : กรุงเทพมหานคร", code: 10, desc: "กรุงเทพมหานคร" },
        getListCC:null,
        typeList:[
            {desc:'สถิติประชากรและบ้าน',code:41},
            {desc:'สถิติการเกิด',code:42},
            {desc:'สถิติการตาย',code:43},
            {desc:'สถิติการย้ายเข้า',code:44},
            {desc:'สถิติการย้ายออก',code:45},
        ],
         setOptions:{
                 tooltips: {
                    callbacks: {
                      label: function (tooltipItem, data) {
                        var tooltipValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                        return parseInt(tooltipValue).toLocaleString();
                      }
                    }
                  },
           scales: {
            yAxes: [{
                ticks: {
                    // Include a dollar sign in the ticks
                    callback: function(value) {
                        return value.toLocaleString();
                    }
                }  
            }]
          }
        },
        piedata:null,
        yymm:{text:'ปี 2561',code: 2561},
        ticketsShowSummary: {
                labels: [],
                barThickness: 10,
                datasets: [
                    {
                        label: "Ingressos validados",
                        backgroundColor: [],
                        data: []
                    }
                ]
            },
        datacollection:null,
         getPlaceList:[
           {text: 'ปี 2554' , code: 2554 },
           {text: 'ปี 2555' , code: 2555 },
           {text: 'ปี 2556' , code: 2556 },
           {text: 'ปี 2557' , code: 2557 },
           {text: 'ปี 2558' , code: 2558 }, 
           {text: 'ปี 2559' , code: 2559 },
           {text: 'ปี 2560' , code: 2560 },
           {text: 'ปี 2561' , code: 2561 },
           {text: 'ปี 2562' , code: 2562 },
         ],
        opt:null,
    chartData:{
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      {
        label: 'การเกิด',
        borderColor: 'rgba(50, 115, 220, 0.5)',
        backgroundColor: 'rgba(50, 115, 220, 0.1)',
        data: [300, 700, 450, 750, 450]
      },
      {
        label: 'การตาย',
        borderColor: 'rgba(255, 56, 96, 0.5)',
        backgroundColor: 'rgba(255, 56, 96, 0.1)',
        data: [600, 550, 750, 250, 700]
      }
    ]
  },
      datacollectionCC: {
      //Data to be represented on x-axis
      labels: [],
      datasets: [
         {
              label: 'บ้านรวม',
              backgroundColor: '#52cb9f',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        },
        {
              label: 'ชาย',
              backgroundColor: '#f49c29',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        },
         {
              label: 'หญิง',
              backgroundColor: '#e74848',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        },
        {
              label: 'รวม',
              backgroundColor: '#8f65b2',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        }
      ],
      
      }
    }
    },
   async created(){
     var d = new Date();
        var n = d.getFullYear()+543;
        var sub =  n.toString().substring(2,4)
         this.setyear = n
      //รายปี
      const response1 = await axios.get("../connectSAPI/stat_forward.php?API=/api/stat/statcenter/v1/list?action=32&yymmBegin="+(this.setyear-10).toString().substring(2,4)+"00&yymmEnd="+ (this.setyear - 1).toString().substring(2,4)+"00")
      this.chartData['labels'] = response1.data.map(r=>{
        return 'ปี25' + r.yymm.toString().substring(0,2)})
      this.chartData.datasets[0].data =response1.data.map(r=>r.total)
      // this.$refs.test.renderChart(this.chartData)
      const response2 = await axios.get("../connectSAPI/stat_forward.php?API=/api/stat/statcenter/v1/list?action=33&yymmBegin="+(this.setyear-10).toString().substring(2,4)+"00&yymmEnd="+ (this.setyear - 1).toString().substring(2,4)+"00")
      // this.chartData['labels'] = response.data.map(r=>r.yymm)
      this.chartData.datasets[1].data =response2.data.map(r=>r.total)
      this.$refs.test.renderChart(this.chartData,this.setOptions)
     
    //   const responseCC = await axios.get("/api/s
    //statcenter/v1/list?action=51&yymmBegin=5100&yymmEnd=6100&cc=10")
    //       let aCC = []
    //         for(let i=0; i<responseCC.data.length; i++){
    //           aCC.push('ปี  '+'25'+responseCC.data[i].yymm.toString().substring(0,2))

    //         }
    //          this.datacollectionCC.datasets[0].data =responseCC.data.map(r=>r.houseNormal)
    //          this.datacollectionCC.datasets[1].data =responseCC.data.map(r=>r.male)
    //          this.datacollectionCC.datasets[2].data = responseCC.data.map(r=>r.female)
    //          this.datacollectionCC.datasets[3].data = responseCC.data.map(r=>r.total)
    //          this.datacollectionCC['labels'] = aCC
    //          this.$refs.test2.renderChart(this.datacollectionCC)
     
    },
   async mounted(){
    
    },
  methods : {
   async checkdata(){
        const responseCC = await axios.get("../connectSAPI/stat_forward.php?API=/api/stat/statcenter/v1/list?action=54&yymmBegin="+(this.setyear-9).toString().substring(2,4)+"00&yymmEnd="+ this.setyear.toString().substring(2,4)+"00&cc="+this.province.code)
           this.chartData['labels'] = response.data.map(r=>r.ccDesc)
           this.chartData.datasets[0].data =response.data.map(r=>r.total)
           
           this.$refs.test.renderChart(this.chartData)
           if(this.statType == 41){
               this.titleText  = 'จำนวนประชากรและบ้าน'
           }else if(this.statType == 42){
               this.titleText  = 'จำนวนการเกิด'
           }else if(this.statType == 43){
               this.titleText  = 'จำนวนการตาย'
           }else if(this.statType == 44){
               this.titleText  = 'จำนวนการย้ายเข้า'
           }else if(this.statType == 45){
               this.titleText  = 'จำนวนการย้ายออก'
           }
     },
   async checkCC(){ 
          this.datacollectionCC =  {
      //Data to be represented on x-axis
      labels: [],
      datasets: [
         {
              label: 'บ้านรวม',
              backgroundColor: '#52cb9f',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        },
        {
              label: 'ชาย',
              backgroundColor: '#f49c29',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        },
         {
              label: 'หญิง',
              backgroundColor: '#e74848',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        },
        {
              label: 'รวม',
              backgroundColor: '#8f65b2',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              data: []
        }
      ],
      
      }
          const responseCC = await axios.get("/api/stat/statcenter/v1/list?action=51&yymmBegin=5100&yymmEnd=6100&cc="+this.province.code)
          console.log('responsecc')
          console.log(response)
          let aCC = []
            for(let i=0; i<responseCC.data.length; i++){
              aCC.push('ปี  '+'25'+responseCC.data[i].yymm.toString().substring(0,2))

            }
             this.datacollectionCC.datasets[0].data =responseCCdata.map(r=>r.houseNormal)
             this.datacollectionCC.datasets[1].data =responseCC.data.map(r=>r.male)
             this.datacollectionCC.datasets[2].data = responseCC.data.map(r=>r.female)
             this.datacollectionCC.datasets[3].data = responseCC.data.map(r=>r.total)
             this.datacollectionCC['labels'] = a 
             this.$refs.test2.renderChart(this.datacollectionCC,this.setOptions)
     

     },
},

  computed:{
  
  },

  }

</script>